import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_AF_FILTER = '/affilter';

export const SET_AF_FILTER_LOADING = 'SET_AF_FILTER_LOADING';
export const GO_TO_AF_FILTER_CREATE = 'GO_TO_AF_FILTER_CREATE';
export const GO_TO_AF_FILTER_EDIT = 'GO_TO_AF_FILTER_EDIT';
export const GO_TO_AF_FILTER_VIEW = 'GO_TO_AF_FILTER_VIEW';
export const GO_TO_AF_FILTER_COPY = 'GO_TO_AF_FILTER_COPY';
export const GO_TO_AF_FILTER_LIST = 'GO_TO_AF_FILTER_LIST';
export const GET_AF_FILTER_LIST = 'GET_AF_FILTER_LIST';
export const GET_AF_FILTER_LIST_PENDING = 'GET_AF_FILTER_LIST_PENDING';
export const GET_AF_FILTER_LIST_FULFILLED = 'GET_AF_FILTER_LIST_FULFILLED';
export const GET_AF_FILTER = 'GET_AF_FILTER';
export const GET_AF_FILTER_PENDING = 'GET_AF_FILTER_PENDING';
export const GET_AF_FILTER_FULFILLED = 'GET_AF_FILTER_FULFILLED';
export const CREATE_AF_FILTER = 'CREATE_AF_FILTER';
export const CREATE_AF_FILTER_PENDING = 'CREATE_AF_FILTER_PENDING';
export const CREATE_AF_FILTER_FULFILLED = 'CREATE_AF_FILTER_FULFILLED';
export const CREATE_AF_FILTER_REJECTED = 'CREATE_AF_FILTER_REJECTED';
export const UPDATE_AF_FILTER = 'UPDATE_AF_FILTER';
export const UPDATE_AF_FILTER_FULFILLED = 'UPDATE_AF_FILTER_FULFILLED';
export const UPDATE_AF_FILTER_REJECTED = 'UPDATE_AF_FILTER_REJECTED';
export const DELETE_AF_FILTER = 'DELETE_AF_FILTER';
export const DELETE_AF_FILTER_FULFILLED = 'DELETE_AF_FILTER_FULFILLED';
export const DELETE_AF_FILTER_REJECTED = 'DELETE_AF_FILTER_REJECTED';
export const SELECT_AF_FILTER = 'SELECT_AF_FILTER';
export const OPEN_AF_FILTER_CREATE_POPUP = 'OPEN_AF_FILTER_CREATE_POPUP';
export const CLOSE_AF_FILTER_CREATE_POPUP = 'CLOSE_AF_FILTER_CREATE_POPUP';

export enum AfFilterPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}
export enum AfFilterMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}
export interface AfFilter {
  id?: string,
  fgId: string,
  afId: string,
  owner?: string,
  group?: string,
  access?: string,
}

export interface AfFilterGridData {
  id?: string,
  fgId: string,
  fgName?: string,
  afId: string,
  afName?: string,
  owner?: string,
  group?: string,
  access?: string,
}

export interface AfFilterState {
  entities: AfFilter[]
  selected: AfFilter[],
  single: AfFilter | null
  createdId: string | null
  ui: AfFiltersUIState
}

export interface AfFiltersUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToAfFilterListAction extends AnyAction {
  type: typeof GO_TO_AF_FILTER_LIST
}

export interface SetAfFilterLoadingAction extends AnyAction {
  type: typeof SET_AF_FILTER_LOADING
  payload: { isLoading: boolean }
}

export interface GetAfFilterListAction extends AnyAction {
  type: typeof GET_AF_FILTER_LIST
  payload: AxiosPromise<ServerResponse<AfFilter>>
}

export interface GetAfFilterListPendingAction extends AnyAction {
  type: typeof GET_AF_FILTER_LIST_PENDING
  payload: null
}

export interface GetAfFilterListFulfilledAction extends AnyAction {
  type: typeof GET_AF_FILTER_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<AfFilter>>
}

export interface GetAfFilterAction extends AnyAction {
  type: typeof GET_AF_FILTER
  payload: AxiosPromise<ServerResponse<AfFilter>>
}

export interface GetAfFilterPendingAction extends AnyAction {
  type: typeof GET_AF_FILTER_PENDING
  payload: null
}

export interface GetAfFilterFulfilledAction extends AnyAction {
  type: typeof GET_AF_FILTER_FULFILLED
  payload: AxiosResponse<ServerResponse<AfFilter>>
}

export interface CreateAfFilterThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface CreateAfFilterAction extends AnyAction {
  type: typeof CREATE_AF_FILTER
  payload: AxiosPromise<ServerResponse<AfFilter>>
}

export interface CreateAfFilterPendingAction extends AnyAction {
  type: typeof CREATE_AF_FILTER_PENDING
  payload: null
}

export interface CreateAfFilterFulfilledAction extends AnyAction {
  type: typeof CREATE_AF_FILTER_FULFILLED
  payload: AxiosResponse<ServerResponse<AfFilter>>
}

export interface CreateAfFilterRejectedAction extends AnyAction {
  type: typeof CREATE_AF_FILTER_REJECTED
  payload: AxiosResponse<ServerResponse<AfFilter>>
}

export interface UpdateAfFilterThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface UpdateAfFilterAction extends AnyAction {
  type: typeof UPDATE_AF_FILTER
  payload: AxiosPromise<ServerResponse<AfFilter>>
}

export interface UpdateAfFilterFulfilledAction extends AnyAction {
  type: typeof UPDATE_AF_FILTER_FULFILLED
  payload: AxiosResponse<ServerResponse<AfFilter>>
}

export interface UpdateAfFilterRejectedAction extends AnyAction {
  type: typeof UPDATE_AF_FILTER_REJECTED
  payload: AxiosResponse<ServerResponse<AfFilter>>
}

export interface DeleteAfFilterThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface DeleteAfFilterAction extends AnyAction {
  type: typeof DELETE_AF_FILTER
  payload: AxiosPromise<ServerResponse<AfFilter>>
}

export interface DeleteAfFilterFulfilledAction extends AnyAction {
  type: typeof DELETE_AF_FILTER_FULFILLED
  payload: AxiosResponse<ServerResponse<AfFilter>>
}

export interface DeleteAfFilterRejectedAction extends AnyAction {
  type: typeof DELETE_AF_FILTER_REJECTED
  payload: AxiosResponse<ServerResponse<AfFilter>>
}

export interface SelectAfFilterAction extends AnyAction {
  type: typeof SELECT_AF_FILTER
  payload: AfFilter[]
}

export interface OpenAfFilterCreatePopupAction extends AnyAction {
  type: typeof OPEN_AF_FILTER_CREATE_POPUP
  payload: { afFilter?: AfFilter }
}

export interface CloseAfFilterCreatePopupAction extends AnyAction {
  type: typeof CLOSE_AF_FILTER_CREATE_POPUP
}

export type AfFilterActionTypes =
  GoToAfFilterListAction |
  SetAfFilterLoadingAction |
  GetAfFilterListAction |
  GetAfFilterListPendingAction |
  GetAfFilterListFulfilledAction |
  GetAfFilterAction |
  GetAfFilterPendingAction |
  GetAfFilterFulfilledAction |
  CreateAfFilterAction |
  CreateAfFilterPendingAction |
  CreateAfFilterFulfilledAction |
  CreateAfFilterRejectedAction |
  UpdateAfFilterAction |
  UpdateAfFilterFulfilledAction |
  UpdateAfFilterRejectedAction |
  DeleteAfFilterAction |
  DeleteAfFilterFulfilledAction |
  DeleteAfFilterRejectedAction |
  SelectAfFilterAction |
  OpenAfFilterCreatePopupAction |
  CloseAfFilterCreatePopupAction;
